module.exports = __webpack_public_path__ + "static/media/IMG_20201031_0011.93363b81.jpg";